import * as types from './types';

export function moveToBudgetLineItemSuccess(id) {
	return { type: types.MOVE_TO_BUDGET_ITEM_SUCCESS, id }
}


export function saveSuccess(details) {
	return { type: types.SAVE_DETAILS_SUCCESS, details }
}

export function moveToLineItem(item) {
	return function (dispatch) {
		dispatch(moveToBudgetLineItemSuccess(item));
	}
}

export function save(user) {
	return function (dispatch) {
		dispatch(saveSuccess(user));
	}
}

export function saveValueSuccess(estimate) {
	return {type: types.SAVE_VALUE_SUCCESS, estimate}
}

export function saveValuesSuccess(estimate) {
	return {type: types.SAVE_VALUES_SUCCESS, estimate}
}
export function saveGridIndexSuccess(estimate) {
	return {type: types.SAVE_GRID_INDEX_SUCCESS, estimate}
}
export function saveSliderIndexSuccess(estimate) {
	return {type: types.SAVE_SLIDER_INDEX_SUCCESS, estimate}
}

export function saveValueFailure(estimate) {
	return {type: types.SAVE_VALUE_FAILURE}
}

export function saveValuesFailure(estimate) {
	return {type: types.SAVE_VALUES_FAILURE}
}
export function saveGridIndexFailure(estimate) {
	return {type: types.SAVE_GRID_INDEX_FAILURE}
}
export function saveSliderIndexFailure(estimate) {
	return {type: types.SAVE_SLIDER_INDEX_FAILURE}
}

export function saveValue(id, value){
	var toPersist = {id: id, value: value};
	return function (dispatch) {
		try {
			dispatch(saveValueSuccess(toPersist));
		} catch(e) {
			console.log(e);
			dispatch(saveValueFailure());
		}
	}
}

export function saveValues(id, value){
	var toPersist = {id: id, value: value};
	return function (dispatch) {
		try {
			dispatch(saveValuesSuccess(toPersist));
		} catch(e) {
			console.log(e);
			dispatch(saveValuesFailure());
		}
	}
}

export function saveGridIndex(id, value){
	var toPersist = {id: id, value: value};
	return function (dispatch) {
		try {
			dispatch(saveGridIndexSuccess(toPersist));
		} catch(e) {
			dispatch(saveGridIndexFailure());
		}
	}
}

export function saveSliderIndex(id, value){
	var toPersist = {id: id, value: value};
	return function (dispatch) {
		try {
			dispatch(saveSliderIndexSuccess(toPersist));
		} catch(e) {
			console.log(e);
			dispatch(saveValueFailure());
		}
	}
}


// WEBPACK FOOTER //
// ./src/actions/estimateActions.js